// date & time validators
import after from './after'
import before from './before'
import dateBetween from './date_between'
import datetimeBetween from './datetime_between'
import date from './date'
import time from './time'
import datetime from './datetime'

// string & number validators
import alpha from './alpha'
import alphadash from './alphadash'
import alphanumeric from './alphanumeric'
import alphaspaces from './alphaspaces'
import decimal from './decimal'
import digits from './digits'
import integer from './integer'
import numeric from './numeric'

// boundary validators
import In from './in'
import between from './between'
import equals from './equals'
import contains from './contains'
import startsWith from './starts_with'
import endsWith from './ends_with'
import minlength from './minlength'
import maxlength from './maxlength'
import min from './min'
import max from './max'

// other validators
import match from './match'
import required from './required'
import has from './has'
import hasOne from './has_one'

// custom validators
import email from './email'
import ip from './ip'
import url from './url'


export default {
    after,
    alphadash,
    alphanumeric,
    alphaspaces,
    alpha,
    before,
    between,
    dateBetween,
    datetimeBetween,
    date,
    time,
    datetime,
    decimal,
    digits,
    email,
    in: In,
    integer,
    ip,
    equals,
    contains,
    startsWith,
    endsWith,
    min,
    max,
    minlength,
    maxlength,
    numeric,
    match,
    required,
    has,
    hasOne,
    url
}
